import React from "react";
// import Footer from './Footer';
import Header from "./Header";
import { IonContent, IonPage } from "@ionic/react";
// import ExploreContainer from '../components/ExploreContainer';

const Layout: React.FC = ({ children }) => {
  return (
    <IonPage>
      <Header />
      <IonContent className="ion-padding" color="medium">
        {children}
      </IonContent>
    </IonPage>
  );
};

export default Layout;
